module.exports = __webpack_public_path__ + "public/img/default.8363580e.png";